export const IsAdultPopupHidden: string = 'IsAdultShowPopup';
